import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { CardiacService } from '../../procedures/cardiac/services/cardiac.service'
import * as actions from '../store/options.actions'

export function* setLeadChangeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const cardiacService = new CardiacService(serviceId)
  try {
    const response: IOptionsResponse = yield call([cardiacService, cardiacService.getLeadChangeOptions])
    const { entity } = response
    yield put(actions.setLeadChangeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setLeadChangeOptions() error: ${e}`))
  }
}
export function* setLeadChangeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setLeadChangeOptions)
}
